import { EventsAPI } from '@/src/api';
import { useApiClient } from '@/src/hooks/api/useApiClient';
import { useTranslation } from 'react-i18next';

export const useEventsApi = () => {
  const { t } = useTranslation();

  return new EventsAPI(useApiClient(), t);
};
